import React from 'react';
import { Button, Space, Typography } from 'antd';

const { Title } = Typography;

type SectionHeaderProps = {
  actionIcon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  title: string;
};

const SectionHeader = ({
  actionIcon,
  actionLabel,
  onAction,
  title,
}: SectionHeaderProps): JSX.Element => {
  return (
    <Space
      align="center"
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <Title level={5} style={{ marginBottom: 0 }}>
        {title}
      </Title>

      {actionLabel && onAction && (
        <Button icon={actionIcon} onClick={onAction} type="dashed">
          {actionLabel}
        </Button>
      )}
    </Space>
  );
};

export default SectionHeader;
